import { render, staticRenderFns } from "./OrderPartseLog.vue?vue&type=template&id=366436d2&scoped=true"
import script from "./OrderPartseLog.vue?vue&type=script&lang=js"
export * from "./OrderPartseLog.vue?vue&type=script&lang=js"
import style0 from "./OrderPartseLog.vue?vue&type=style&index=0&id=366436d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366436d2",
  null
  
)

export default component.exports